import axios from 'axios';

axios.interceptors.request.use(
  (config) => {
    // Try to get websiteId from localStorage which is set by WebsiteContext
    // Alternatively, we could parse window.location.pathname
    let websiteId = localStorage.getItem('currentWebsiteId');
    
    if (!websiteId) {
        const pathParts = window.location.pathname.split('/');
        if (pathParts.length > 1 && pathParts[1]) {
            websiteId = pathParts[1];
        }
    }

    if (websiteId) {
      // Add websiteId to params for all requests (easiest way to pass it without breaking body structure sometimes)
      // Or strictly follow method types.
      
      // Add to query params
      config.params = { ...config.params, websiteId };

      // Add to body for mutation requests if it's a JSON object
      if (['post', 'put', 'patch'].includes(config.method)) {
        if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
             // Only merge if it's a plain object
             try {
                config.data = { ...config.data, websiteId };
             } catch (e) {
                 // ignore if spread fails
             }
        }
      }
      
      // Add header
      config.headers['X-Website-ID'] = websiteId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
